export const UNRESOLVED_IDENTITY = Object.freeze({
  resolved: false,
  recordId: null,
  recordKey: null,
  source: null,
  matchedAlias: null,
  entity: null,
  entityField: null,
});

export function resolveIdentity(entry, debugData) {
  const idKeyMatch = resolveIdKeys(entry.idKeys, debugData);
  if (idKeyMatch) {
    return {
      resolved: true,
      recordId: idKeyMatch.value,
      recordKey: String(idKeyMatch.value),
      source: 'idKeys',
      matchedAlias: idKeyMatch.key,
      entity: idKeyMatch.entity ?? entry.entity,
      entityField: idKeyMatch.entityField ?? 'id',
    };
  }

  const compositeMatch = resolveCompositeIdKeys(entry.compositeIdKeys, debugData);
  if (compositeMatch) {
    return {
      resolved: true,
      recordId: compositeMatch.values,
      recordKey: compositeMatch.values.join('|'),
      source: 'compositeIdKeys',
      matchedAlias: null,
      entity: entry.entity,
      entityField: 'id',
    };
  }

  return UNRESOLVED_IDENTITY;
}

function resolveIdKeys(idKeys = [], debugData) {
  for (const alias of idKeys) {
    const { key, entity, entityField, whenKey } =
      typeof alias === 'string' ? { key: alias, entity: null, entityField: null, whenKey: null } : alias;
    const value = debugData?.[key];
    const guardHolds = whenKey == null || debugData?.[whenKey] != null;
    if (value != null && guardHolds) return { key, value, entity, entityField };
  }
  return null;
}

function resolveCompositeIdKeys(compositeIdKeys, debugData) {
  if (!compositeIdKeys?.length) return null;
  const values = compositeIdKeys.map(key => debugData?.[key]);
  if (values.some(v => v == null)) return null;
  return { values };
}
